//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkPasswordFun } from "@/utils/pwdCheck";
import { changePwd } from "@/api/system/user";
export default {
  name: "PWDEdit",
  components: {},
  filters: {},
  data: function data() {
    return {
      queryform: {
        oldPassword: '',
        newPassword: '',
        cofirmPassword: ''
      }
    };
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pwdDialogShow: {
      get: function get() {
        return this.dialogShow;
      },
      set: function set(val) {
        if (!val) {
          // this.$refs["queryMenuform"].resetFields();
          this.queryform = {};
        }
        this.$emit("update:dialogShow", val);
      }
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    pwdCheck: function pwdCheck(rule, value, callback) {
      if (rule.field === 'cofirmPassword') {
        if (this.queryform.newPassword !== this.queryform.cofirmPassword) {
          return callback(new Error('密码输入不一致'));
        }
      }
      var checkItem = checkPasswordFun(value, 12, 16);
      if (checkItem.flag) {
        callback();
      } else {
        return callback(new Error(checkItem.message));
      }
    },
    closeDialog: function closeDialog() {
      this.$refs["queryPwdform"].resetFields();
      this.pwdDialogShow = false;
    },
    pwdCancel: function pwdCancel() {
      this.pwdDialogShow = false;
    },
    pwdConfirm: function pwdConfirm() {
      var _this2 = this;
      var _this = this;
      this.$refs["queryPwdform"].validate(function (valid) {
        if (valid) {
          changePwd(_this2.queryform).then(function (res) {
            if (res.code === 200) {
              _this.$message({
                type: 'success',
                message: '密码修改成功!'
              });
              _this.$store.dispatch("updateUserInfo", res.data.userInfo);
              _this.pwdDialogShow = false;
              _this.$emit("pwdChange");
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};